module.exports = __webpack_public_path__ + "img/tengxunMap.ccdd2949.png";